import axios from 'axios';
import { CLIENT_BASIC_SEARCH_URL, CLIENT_SEARCH_URL, toSearchBody } from 'utils/clientSearch';

export const authService = {
    getClientsService: ({ data }) => axios.post(CLIENT_SEARCH_URL, toSearchBody(data), { auth: true }),

    // Takes no filters — don't send the grid's (search text is PHI and would land in the URL).
    getClientExpirationService: () => axios.get('/client/auth-expiration/counts', { auth: true }),

    getBasicClientsService: (params) =>
        axios.post(
            CLIENT_BASIC_SEARCH_URL,
            toSearchBody({
                ...params,
                sortType: params?.sortType ? params?.sortType : 'code',
                orderType: params?.orderType ? params.orderType : 'ASC',
            }),
            { auth: true }
        ),

    createClientService: ({ payload }) => axios.post(`/client`, payload.body, { auth: true }),

    createIntakeFormService: (params) => axios.post(`/custom-forms-invite/send-invite`, params, { auth: true }),

    resendClientInviteService: (id, params) => axios.patch(`/client/sendInvite/${id}`, params, { auth: true }),

    deleteClientService: ({ payload }) => axios.delete(`/client/${payload.id}`, { auth: true }),

    editClientService: ({ payload }) => axios.patch(`/client/${payload.id}`, payload.body, { auth: true }),

    getClientByIdService: ({ payload }) => axios.get(`/client/${payload.id}`, { auth: true }),

    getClientContactInfoService: ({ payload }) =>
        axios.get(`/contact/guardian/client/${payload.id}`, {
            auth: true,
            params: { ...payload?.data },
        }),

    createClientContactService: ({ payload }) => axios.post(`/contact/client/${payload.id}`, payload.body, { auth: true }),

    editClientContactService: ({ payload }) => axios.patch(`/contact/${payload.id}`, payload.body, { auth: true }),

    deleteClientContactService: ({ payload }) => axios.delete(`/contact/${payload.id}/client/${payload.paramsId}`, { auth: true }),

    /** Client Statuses */

    setClientStatus: (id, body) => axios.patch(`/client/${id}/status`, body, { auth: true }),

    /** End */

    /** Client Enrollment */
    getEnrollmentPayersService: (id) => axios.get(`/enrollment/payers/client/${id}`, { auth: true }),

    getClientEnrollmentService: ({ payload }) =>
        axios.get(`/enrollment/client/${payload.id}`, {
            auth: true,
            params: payload?.params,
        }),

    createClientEnrollmentService: ({ payload }) =>
        axios.post(`/enrollment/client/${payload.id}/funder/${payload.funderId}`, payload.body, { auth: true }),

    editClientEnrollmentService: ({ payload }) => axios.patch(`/enrollment/${payload.id}`, payload.body, { auth: true }),

    terminateClientEnrollmentService: (id, body) => axios.patch(`/enrollment/${id}/terminate`, { ...body }, { auth: true }),

    deleteClientEnrollmentService: ({ payload }) => axios.delete(`/enrollment/${payload.id}`, { auth: true }),

    changeEnrollmentTypeService: (payload) =>
        axios.patch(`/enrollment/${payload.enrolmentId}/client/${payload?.clientId}/primary`, null, {
            auth: true,
            params: { type: payload?.type },
        }),
    /** End */

    /** Staff Documents */

    addClientAddressService: ({ id, body }) => axios.post(`/client/${id}/address`, { ...body }, { auth: true }),

    editClientAddressService: ({ id, addressId, body }) => axios.patch(`/client/${id}/address/${addressId}`, { ...body }, { auth: true }),

    deleteClientAddressService: ({ id, addressId }) => axios.delete(`/client/${id}/address/${addressId}`, { auth: true }),

    getClientSchedulingAddressService: ({ id }) => axios.get(`/client/${id}/scheduling-address`, { auth: true }),

    setClientSchedulingAddressService: ({ id, body }) => axios.patch(`/client/${id}/scheduling-address`, { ...body }, { auth: true }),

    clearClientSchedulingAddressService: ({ id }) => axios.delete(`/client/${id}/scheduling-address`, { auth: true }),

    /** End */

    /** Staff Assignment */

    assignStaffService: (body) => axios.post('/clients/assigned-staff', body, { auth: true }),

    editAssignedStaffService: (id, body) => axios.patch(`/clients/assigned-staff/${id}`, body, { auth: true }),

    getAssignedStaffService: (id) => axios.get(`/clients/assigned-staff/byClient/${id}`, { auth: true }),

    removeClientStaffService: (id) => axios.delete(`/clients/assigned-staff/${id}`, { auth: true }),

    /** End */

    /** Client Authorization */

    getClientAuthorizationsService: (id) => axios.get(`/authorizedService/client/${id}`, { auth: true }),

    /** One page of the authorization utilization timeline: `{ clients: [{ client, authorizations }], count }`. */
    getAuthUtilizationService: (params) => axios.get('/authorizedService/utilization', { auth: true, params }),

    getClientAuthorizationApptService: (id, type, showExpired) =>
        type === 'Self'
            ? axios.get(`/appt/services/available`, { auth: true, params: { clientId: id } })
            : axios.get(`/authorizedService/appt/client/${id}`, { auth: true, params: { showExpired: showExpired || undefined } }),

    addClientAuthorizationService: (id, body) => axios.post(`/authorizedService/client/${id}`, body, { auth: true }),

    editClientAuthorizationService: (id, body) => axios.patch(`/authorizedService/client/${id}`, body, { auth: true }),

    deleteAuthorizedServiceService: (id) => axios.delete(`/authorizedService/${id}`, { auth: true }),

    inactivateClientAuthorizationService: (id, reason) =>
        axios.patch(
            `/authorizedService/inactivate/${id}`,
            {},
            {
                auth: true,
                params: { reason: reason },
            }
        ),

    cancelClientAuthorizationService: (clientId, params) =>
        axios.patch(
            `/authorizedService/cancel/client/${clientId}`,
            {},
            {
                auth: true,
                params: params,
            }
        ),

    deleteClientAuthorizationService: (clientId, params) =>
        axios.delete(`/authorizedService/client/${clientId}/authorization`, {
            auth: true,
            params: params,
        }),

    clientAuthorizationVisible: (id, isApptVisible) =>
        axios.patch(
            `/authorizedService/${id}/apptVisible`,
            {},
            {
                auth: true,
                params: { isApptVisible: isApptVisible },
            }
        ),

    checkChargeRates: (params) =>
        axios.get('/authorizedService/checkChargeRates', {
            auth: true,
            params: {
                ...params,
                // fundingServiceId: fundingServiceId,
                // authId: authId,
            },
        }),

    /** Client Authorization Documents */
    getClientAuthFilesService: (clientId, params) =>
        axios.get(`/authorizedService/client/${clientId}/documents`, { auth: true, params: { ...params } }),

    addFilesToClientAuthService: ({ clientId, params, files }) =>
        axios.post(`/authorizedService/client/${clientId}/documents`, files, { auth: true, params: params }),

    removeFilesFromClientAuthService: ({ clientId, params, docId }) =>
        axios.delete(`/authorizedService/client/${clientId}/documents/${docId}`, {
            auth: true,
            params: params,
        }),

    editFileNameOfClientAuthService: ({ clientId, params, docId, fileName }) =>
        axios.patch(`/authorizedService/client/${clientId}/documents/${docId}`, null, {
            auth: true,
            params: { ...params, name: fileName },
        }),

    getClientsAuthorizationApptService: (authId, status) =>
        axios.get(`/appt/authorizedService/${authId}`, { auth: true, params: { apptStatus: status } }),

    /** Contact Search & Link */
    searchContactsService: (searchValue, excludeClientId) =>
        axios.get('/contact/search', { auth: true, params: { searchValue, excludeClientId } }),

    linkContactToClientService: (contactId, clientId, grantPortalAccess) =>
        axios.post(`/contact/${contactId}/link/${clientId}`, { grantPortalAccess: !!grantPortalAccess }, { auth: true }),

    getClientContactsService: (clientId, params) => axios.get(`/contact/client/${clientId}`, { auth: true, params: params }),

    grantPortalAccessService: (clientId, contactId) => axios.patch(`/client/${clientId}/portal/grant/${contactId}`, {}, { auth: true }),

    revokePortalAccessService: (clientId, contactId) => axios.patch(`/client/${clientId}/portal/revoke/${contactId}`, {}, { auth: true }),

    setClientContactPasswordService: (id, body) => axios.patch(`/authn/${id}/set-password`, body, { auth: true }),

    /** Forms */
    getClientFormsService: (clientId, params) => axios.get(`/client/${clientId}`, { auth: true, params: params }),

    deleteClientFormsService: (clientId, formId, params) =>
        axios.delete(`/client/${clientId}/form/${formId}`, { auth: true, params: params }),

    addClientFormsService: (clientId, params) => axios.post(`/client/${clientId}/form`, params, { auth: true }),

    /** Client Sections */

    getClientSectionsService: (clientId) => axios.get(`/client/${clientId}/custom-section`, { auth: true }),

    getClientSectionByIdService: (clientId, sectionId) => axios.get(`/client/${clientId}/custom-section/${sectionId}`, { auth: true }),

    createClientSectionService: (clientId, body) => axios.post(`/client/${clientId}/custom-section`, body, { auth: true }),

    editClientSectionService: (clientId, sectionId, body) =>
        axios.patch(`/client/${clientId}/custom-section/${sectionId}`, body, { auth: true }),

    deleteClientSectionService: (clientId, sectionId) => axios.delete(`/client/${clientId}/custom-section/${sectionId}`, { auth: true }),

    /** Client Documentation Notes */
    getClientAllNotesService: (params, clientId) => axios.get(`/note/client/${clientId}/documentation`, { auth: true, params: params }),

    deleteClientAllNotesSagaService: (docId) => axios.delete(`/note/document/${docId}`, { auth: true }),

    /** One Forms-tab form as a PDF (any type but a progress report, which has its own PDF). */
    downloadClientDocumentService: (clientId, docId) =>
        axios.get(`/note/client/${clientId}/documentation/${docId}/download`, { auth: true, responseType: 'blob' }),
};
